import { render } from "./datetime-picker.md?vue&type=template&id=f238d86c"
import script from "./datetime-picker.md?vue&type=script&lang=js"
export * from "./datetime-picker.md?vue&type=script&lang=js"
script.render = render

export default script